export const EMAIL_VALIDATOR = "Błędny format adresu email! Wymagane user@example.com";
export const PHONE_VALIDATOR = "Błędny format nr. telefonu! Wymagane 000000000";
export const LENGTH_VALIDATOR = (length: number) => `To pole musi mieć ${length} znaków`;
export const MIN_VALIDATOR = (min: number) => `Minimalna wartość to: ${min}`;
export const REQUIRED_VALIDATOR = "To pole jest wymagane";
export const ZIP_CODE_VALIDATOR = "Błędny format kodu pocztowego! Wymagane 00-000";
export const PASSWORD_VALIDATOR =
  "Ze względów bezpieczeństwa hasło powinno składać się z min. 8 znaków zawierających małe i wielkie litery oraz cyfry lub znaki specjalne";
export const PASSWORDS_DO_NOT_MATCH = "Hasła nie są zgodne!";
export const EMAIL_DO_NOT_MATCH = "Emaile nie są zgodne!";
export const NIP_VALIDATOR = "Błedny format! Wymagane (0000000000)";
export const SPECIAL_CHARACTER_VALIDATOR = "To pole nie może zawierać znaków specjalnych";
export const ONLY_NUMBER_VALIDATOR = "To pole może zawierać wyłącznie cyfry";
export const ONLY_TEXT_VALIDATOR = "To pole nie może zawierać znaków specjalnych i cyfr";
export const LAST_NAME_VALIDATOR =
  "Proszę podać poprawne nazwisko. Nazwisko powinno składać się wyłącznie z liter lub być dwuczłonowe, oddzielone łącznikiem.";
